var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28.64 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1e3859;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m11.25,2.07C11.25.93,10.41,0,9.38,0h-3.75C2.52,0,0,2.78,0,6.21v16.57c0,3.43,2.52,6.21,5.62,6.21h3.75c1.04,0,1.88-.93,1.88-2.07s-.84-2.07-1.87-2.07h-3.75c-1.04,0-1.87-.93-1.87-2.07V6.21c0-1.15.84-2.07,1.88-2.07h3.75c1.04,0,1.88-.93,1.88-2.07Zm16.95,13.73c.28-.29.44-.7.44-1.13s-.16-.84-.44-1.13l-8.44-8.8c-.41-.43-1.01-.54-1.52-.3-.52.25-.85.81-.85,1.42v4.66h-7.5c-1.04,0-1.88.93-1.88,2.07v4.14c0,1.15.84,2.07,1.88,2.07h7.5v4.66c0,.62.33,1.18.85,1.42.52.25,1.11.13,1.52-.3l8.44-8.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.b538da0667ecde087b71b89462482fbd.svg";
export { ForwardRef as ReactComponent };